export default {
	TABLE_TITLE: 'Currency denominations',
	CURRENCY_DENOMINATIONS_ADDED: 'Currency denominations added',
	CURRENCY_DENOMINATIONS_EDITED: 'Currency denominations edited',
	CURRENCY_DENOMINATIONS_DELETED: 'Currency denominations deleted',
};
